import React, { useEffect, useState } from "react";
import { Menu } from "antd";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import CustomScrollbars from "util/CustomScrollbars";
import SidebarLogo from "./SidebarLogo";
import UserProfile from "./UserProfile";

import "../Auth.css";

import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE,
} from "../../constants/ThemeSetting";

const { SubMenu } = Menu;

const SidebarContent = ({ sidebarCollapsed, setSidebarCollapsed }) => {
  const { navStyle, themeType } = useSelector(({ settings }) => settings);
  const pathname = useSelector(({ common }) => common.pathname);
  const { user } = useSelector(({ auth }) => auth);

  const [selectedKey, setSelectedKey] = useState("");
  const [openKeys, setOpenKeys] = useState([]);

  const roleDetails = user?.roleDetails || [];

  useEffect(() => {
    setSelectedKey(pathname?.replace("/", ""));
  }, [pathname]);

  const getNoHeaderClass = () => {
    return [
      NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
      NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
    ].includes(navStyle)
      ? "gx-no-header-notifications"
      : "";
  };

  const getLinkStyle = (tabUrl) => ({
    color: selectedKey === tabUrl ? "#fa8c15" : "inherit",
  });

  const renderMenuItem = (item, isChild = false) => (
    <Menu.Item
      key={item._id}
      style={{
        textTransform: "capitalize",
        ...(isChild && {
          width: "350px",
          marginLeft: "-20px",
        }),
      }}
    >
      <Link
        to={item.hasView ? `/${item.tabUrl}` : "/erropage"}
        style={getLinkStyle(item.tabUrl)}
      >
        <i className="icon icon-user" />
        <span>{item.displayName}</span>
      </Link>
    </Menu.Item>
  );

  const renderSubMenu = (item) => (
    <SubMenu
      key={item._id}
      title={
        <Link to="#" onClick={(e) => e.preventDefault()}>
          <span>
            <i className="icon icon-user" />
            <span>{item.displayName}</span>
          </span>
        </Link>
      }
    >
      {item.children
        ?.filter((child) => child.isActive)
        .map((child) => renderMenuItem(child, true))}
    </SubMenu>
  );

  const menuItems = roleDetails
    .filter((item) => item.isActive)
    .map((item) =>
      item.children?.length ? renderSubMenu(item) : renderMenuItem(item),
    );

  return (
    <>
      <SidebarLogo
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
      />

      <div
        className="gx-sidebar-content side-bar-scroll"
        style={{ height: "90%", width: "105%" }}
      >
        <div className={`gx-sidebar-notifications ${getNoHeaderClass()}`}>
          <UserProfile />
        </div>

        <CustomScrollbars style={{ height: "80%", overflow: "auto" }}>
          <Menu
            mode="inline"
            openKeys={openKeys}
            selectedKeys={[selectedKey]}
            onOpenChange={setOpenKeys}
            theme={themeType === THEME_TYPE_LITE ? "lite" : "dark"}
          >
            {(user?.userType === "admin" || user?.userType === "sub admin") &&
              menuItems}
          </Menu>
        </CustomScrollbars>
      </div>
    </>
  );
};

export default React.memo(SidebarContent);
